module.exports = __webpack_public_path__ + "static/img/steps.9d597d2.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/steps.svg
// module id = bOTl
// module chunks = 4